// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"d0f1e9d9","485":"d714edc8"}[chunkId] + ".chunk.css";
};